import { createSlice } from '@reduxjs/toolkit'


export const verifyDetailSlice = createSlice({
  name: 'verifyDetail',
  initialState: {
    title:null,
    fnameTH: null,
    lnameTH:null,
    fnameEN: null,
    lanameEN:null,
    loading:false,
    cid:null,
    addressWork:null,
    tel:null,
    phone:null,
    email:null,
    position:'',
    sub_organization:'',
    organization:'',
    tax_id:'',
    o:'',
    titleFeedback:'',
    fnameTHFeedback:'',
    lnameTHFeedback:'',
    fnameENFeedback:'',
    lnameENFeedback:'',
    cidFeedback:'',
    addressFeedback:'',
    telFeedback:'',
    phoneFeedback:'',
    emailFeedback:'',
    checkEdit:true,
    checked:false,
    open:false
  },
  reducers: {
    setTitleRedux: (state, action) => {
      const { title } = action.payload
      state.title = title
    },
    setFNameTHRedux: (state, action) => {
        const { fnameTH } = action.payload
        state.fnameTH = fnameTH
      },
    setLNameTHRedux: (state, action) => {
        const { lnameTH } = action.payload
        state.lnameTH = lnameTH
      },
      setFNameENRedux: (state, action) => {
        const { fnameEN } = action.payload
        state.fnameEN = fnameEN
      },
      setLNameENRedux: (state, action) => {
        const { lnameEN } = action.payload
        state.lnameEN = lnameEN
      },
      setLoadingRedux: (state, action) => {
        const { loading } = action.payload
        state.loading = loading
      },
      setCidRedux: (state, action) => {
        const { cid } = action.payload
        state.cid = cid
      },
      setAddressWorkRedux: (state, action) => {
        const { addressWork } = action.payload
        state.addressWork = addressWork
      },
      setTelRedux: (state, action) => {
        const { tel } = action.payload
        state.tel = tel
      },
      setPhoneRedux: (state, action) => {
        const { phone } = action.payload
        state.phone = phone
      },
      setEmailRedux: (state, action) => {
        const { email } = action.payload
        state.email = email
      },
      setPositionRedux: (state, action) => {
        const { position } = action.payload
        state.position = position
      },
      setSubOrganizationRedux: (state, action) => {
        const { sub_organization } = action.payload
        state.sub_organization = sub_organization
      },
      setOrganizationRedux: (state, action) => {
        const { organization } = action.payload
        state.organization = organization
      },
      setTaxIDRedux: (state, action) => {
        const { tax_id } = action.payload
        state.tax_id = tax_id
      },
      setORedux: (state, action) => {
        const { o } = action.payload
        state.o = o
      },
      setTitleFeedbackRedux: (state, action) => {
        const { titleFeedback } = action.payload
        state.titleFeedback = titleFeedback
      },
      setFNameTHFeedbackRedux: (state, action) => {
        const { fnameTHFeedback } = action.payload
        state.fnameTHFeedback = fnameTHFeedback
      },
      setLNameTHFeedbackRedux: (state, action) => {
        const { lnameTHFeedback } = action.payload
        state.lnameTHFeedback = lnameTHFeedback
      },
      setFNameENFeedbackRedux: (state, action) => {
        const { fnameENFeedback } = action.payload
        state.fnameENFeedback = fnameENFeedback
      },
      setLNameENFeedbackRedux: (state, action) => {
        const { lnameENFeedback } = action.payload
        state.lnameENFeedback = lnameENFeedback
      },
      setCidFeedbackRedux: (state, action) => {
        const { cidFeedback } = action.payload
        state.cidFeedback = cidFeedback
      },
      setAddressFeedbackRedux: (state, action) => {
        const { addressFeedback } = action.payload
        state.addressFeedback = addressFeedback
      },
      setTelFeedbackRedux: (state, action) => {
        const { telFeedback } = action.payload
        state.telFeedback = telFeedback
      },
      setPhoneFeedbackRedux: (state, action) => {
        const { phoneFeedback } = action.payload
        state.phoneFeedback = phoneFeedback
      },
      setEmailFeedbackRedux: (state, action) => {
        const { emailFeedback } = action.payload
        state.emailFeedback = emailFeedback
      },
      setCheckEditRedux: (state, action) => {
        const { checkEdit } = action.payload
        state.checkEdit = checkEdit
      },
      setCheckedRedux: (state, action) => {
        const { checked } = action.payload
        state.checked = checked
      },
      setOpenRedux: (state, action) => {
        const { open } = action.payload
        state.open = open
      },
  },
})

export default verifyDetailSlice.reducer;

export const {
    setTitleRedux,
    setFNameTHRedux,
    setLNameTHRedux,
    setFNameENRedux,
    setLNameENRedux,
    setLoadingRedux,
    setCidRedux,
    setAddressWorkRedux,
    setTelRedux,
    setPhoneRedux,
    setEmailRedux,
    setPositionRedux,
    setSubOrganizationRedux,
    setOrganizationRedux,
    setTaxIDRedux,
    setORedux,
    setTitleFeedbackRedux,
    setFNameTHFeedbackRedux,
    setLNameTHFeedbackRedux,
    setFNameENFeedbackRedux,
    setLNameENFeedbackRedux,
    setCidFeedbackRedux,
    setAddressFeedbackRedux,
    setTelFeedbackRedux,
    setPhoneFeedbackRedux,
    setEmailFeedbackRedux,
    setCheckEditRedux,
    setCheckedRedux,
    setOpenRedux
} = verifyDetailSlice.actions

export const getTitleRedux = (state) => state.verifyDetail.title
export const getFNameTHRedux = (state) => state.verifyDetail.fnameTH
export const getLNameTHRedux = (state) => state.verifyDetail.lnameTH
export const getFNameENRedux = (state) => state.verifyDetail.fnameEN
export const getLNameENRedux = (state) => state.verifyDetail.lnameEN
export const getLoadingRedux = (state) => state.verifyDetail.loading
export const getCidRedux = (state) => state.verifyDetail.cid
export const getAddressWorkRedux = (state) => state.verifyDetail.addressWork
export const getTelRedux = (state) => state.verifyDetail.tel
export const getPhoneRedux = (state) => state.verifyDetail.phone
export const getEmailRedux = (state) => state.verifyDetail.email
export const getPositionRedux = (state) => state.verifyDetail.position
export const getSubOrganizationRedux = (state) => state.verifyDetail.sub_organization
export const getOrganizationRedux = (state) => state.verifyDetail.organization
export const getTaxIDRedux = (state) => state.verifyDetail.tax_id
export const getORedux = (state) => state.verifyDetail.o
export const getTitleFeedbackRedux = (state) => state.verifyDetail.titleFeedback
export const getFNameTHFeedbackRedux = (state) => state.verifyDetail.fnameTHFeedback
export const getLNameTHFeedbackRedux = (state) => state.verifyDetail.lnameTHFeedback
export const getFNameENFeedbackRedux = (state) => state.verifyDetail.fnameENFeedback
export const getLNameENFeedbackRedux = (state) => state.verifyDetail.lnameENFeedback
export const getCidFeedbackRedux = (state) => state.verifyDetail.cidFeedback
export const getAddressFeedbackRedux = (state) => state.verifyDetail.addressFeedback
export const getTelFeedbackRedux = (state) => state.verifyDetail.telFeedback
export const getPhoneFeedbackRedux = (state) => state.verifyDetail.phoneFeedback
export const getEmailFeedbackRedux = (state) => state.verifyDetail.emailFeedback
export const getCheckEditRedux = (state) => state.verifyDetail.checkEdit
export const getCheckedRedux = (state) => state.verifyDetail.checked
export const getOpenRedux = (state) => state.verifyDetail.open



























